module.exports = __webpack_public_path__ + "dingbeauty-build/img/person.ba802632.svg";